<kendo-dialog id="inactive-assess" title="Inactivate Assessments Line Items" 
  class="custom-dialog"   (close)="onCloseDialog()"  [width]="530" [maxHeight]="230">
  <!-- <div *ngIf="loadSpinner" class="k-d-flex k-w-full k-justify-content-center">
    <kendo-loader type="converging-spinner" size="large"></kendo-loader>
</div> -->
  <div class="msg">This will effectively remove {{assessmentListSelection?.length}} line item(s) from the Assessments Contract Award List. Do you want to continue? </div>
  <kendo-dialog-actions>
    <!-- <button kendoButton  fillMode="solid"   (click)="closeDialog()" >Cancel</button> -->
    <button kendoButton  themeColor="error" (click)="inactive()" fillMode="solid">Inactivate</button>
  </kendo-dialog-actions>
</kendo-dialog>